angular.module('e360')
   .directive('stateSelect', stateSelectDirective);

var templateUrl = require('./state-select.html');

stateSelectDirective.$inject = ['$timeout'];
function stateSelectDirective($timeout) {
   return {
      restrict: 'E',
      require: ['^^countryStates', 'ngModel'],
      transclude: true,
      templateUrl: templateUrl,
      link: stateSelectDirectiveLink
   };

   function stateSelectDirectiveLink(scope, element, attrs, ctrls) {
      var countryStatesCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];

      scope.$watch(attrs.ngModel, onStateChange);
      countryStatesCtrl.onCountrySelect = onCountrySelect;

      function onStateChange(newVal, oldVal, scope) {
         if (newVal) {
            // when state select directive is positioned before the country
            // select directive in the DOM and both the state and country
            // ngModel values are set in the same digest cycle the
            // onCountryChange function in the countryStatesCtrl runs after
            // this watch expression is run, which means states list doesn't
            // reflect current country...
            // running this in the next digest cycle with $timeout ensures
            // we run after onCountryChange when states list is correct
            $timeout(function() {
               var state = _.findWhere(countryStatesCtrl.states, {code: newVal});
               if (!state) {
                  state = _.findWhere(countryStatesCtrl.states, {name: newVal});
               }

               if (state) {
                  ngModelCtrl.$setViewValue(state);
                  ngModelCtrl.$render();

                  if (countryStatesCtrl.onStateSelect) {
                     countryStatesCtrl.onStateSelect({state: state});
                  }
               }
            });
         }
      }

      function onCountrySelect() {
         // some bug in ui-select leaves previously selected state
         // when states list changes... this is the workaround
         ngModelCtrl.$setViewValue(null);
         ngModelCtrl.$modelValue = null;
         countryStatesCtrl.onStateSelect({state: null});
      }
   }
}
